import { Controller } from 'stimulus';

export default class extends Controller {
  connect() {
    this.set_events();
  }

  /*
   * イベント設定
   */
  set_events() {
    $(document).ready(function() {
      let default_value = '';
      let btn_submit = $('#memo-submit');
      let input = $('#memo');
      default_value = $('#memo').val();

      input.on('keyup', function() {
        if( $(this).val() === '' ) {
          btn_submit.addClass('stop_submit');
          return false;
        }

        if ($(this).val() === default_value) {
          btn_submit.addClass('stop_submit');
        } else {
          btn_submit.removeClass('stop_submit');
        }
      });

      // サブミット中の多重送信を止める
      btn_submit.on('click', function() {
        btn_submit.addClass('stop_submit');
      });
    });
  }
}
